import api from "PFCore/api";

export type DeleteMessageResponse = {
  message: string;
};

export const deleteMessage = (id: string): Promise<DeleteMessageResponse> =>
  api({
    method: "DELETE",
    url: `chat/messages/${id}`
  });
